import React, { useEffect } from 'react'
import { Analysis } from '../../services/analysisService'
import GenericError from './GenericError'

const Error404Page = () => {
  useEffect(() => {
    Analysis.sendSegmentPageEvent(
      Analysis.SEGMENT_PAGE_CATEGORIES.Error,
      Analysis.SEGMENT_EVENTS['Error Page 404']
    )
  }, [])

  return <GenericError />
}

export default Error404Page
